import React from 'react';
import ReactDOM from 'react-dom';
import Fluxible from 'fluxible';
import FluxibleComponent from 'fluxible-addons-react/FluxibleComponent';
import DraftStore from './stores/DraftStore';
import LaunchRouter from './routes/LaunchRouter';
import BriefDesignStore from './stores/BriefDesignStore';
import BriefAttributeStore from './stores/BriefAttributeStore';
import DraftStepStore from './stores/DraftStepStore';
import BriefColorStore from './stores/BriefColorStore';
import UrlStore from 'launch/stores/UrlStore';
import BriefPackageTypeStore from './stores/BriefPackageTypeStore';
import BriefBookTypeStore from './stores/BriefBookTypeStore';
import BriefStore from './stores/BriefStore';
import UserStore from './stores/UserStore';
import { IntlProvider } from 'react-intl';
import FastClick from 'fastclick';
import Modal from 'react-modal';
import { loadDraftData, loadDraftRoutes } from 'launch/actions/designBriefActions';
import { loadUserData } from 'launch/actions/userActions';
import { loadUrls } from 'launch/actions/urlActions';
import { loadIntlDataForLocale } from 'common/utils/intl';

let root = document.querySelector('[data-launch-app]');
let app = new Fluxible();
let ctx = app.createContext({});

app.registerStore(DraftStore);
app.registerStore(DraftStepStore);
app.registerStore(BriefDesignStore);
app.registerStore(BriefAttributeStore);
app.registerStore(BriefColorStore);
app.registerStore(BriefPackageTypeStore);
app.registerStore(BriefBookTypeStore);
app.registerStore(BriefStore);
app.registerStore(UserStore);
app.registerStore(UrlStore);

loadIntlDataForLocale(global.intlData.locale).then(() => {
    ctx.getActionContext().executeAction(loadDraftData, global.draft)
        .then(() => ctx.getActionContext().executeAction(loadUserData, {
            isLoggedIn: window.user ? window.user['is_logged_in'] : false,
            language: global.intlData.locale.split('-')[0],
        }))
        .then(() => ctx.getActionContext().executeAction(loadDraftRoutes, {
            steps: global.draftSteps,
            currentPath: window.location.pathname
        }))
        .then(() => ctx.getActionContext().executeAction(loadUrls, {
            urls: global.urls
        }))
        .then(() => {
            // Render the app
            ReactDOM.render(
                <FluxibleComponent context={ctx.getComponentContext()}>
                    <IntlProvider {...global.intlData}>
                        <LaunchRouter />
                    </IntlProvider>
                </FluxibleComponent>,
                root
            );

            // Set up modal placeholder
            Modal.setAppElement(root);

            if ('addEventListener' in document) {
                document.addEventListener('DOMContentLoaded', function() {
                    FastClick.attach(document.body);
                }, false);
            }
        });
});



// WEBPACK FOOTER //
// ./js/launch/draft.jsx